import styled from "styled-components";

export const AvatarPreview = styled.img`
  width: 358px;
  height: 358px;
  object-fit: fill;
  border-radius: 50%;
  margin-left: auto;
  margin-right: auto;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    width: 396px;
    height: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
    height: 348px;
  }

  @media (min-width: 1024px) {
    width: 310px;
    height: 310px;
  }

  @media (min-width: 1440px) {
    width: 448px;
    height: 448px;
  }
`;
